import { render } from "./CaseSummary.vue?vue&type=template&id=adc868dc&ts=true"
import script from "./CaseSummary.vue?vue&type=script&lang=ts"
export * from "./CaseSummary.vue?vue&type=script&lang=ts"

import "./CaseSummary.vue?vue&type=style&index=0&id=adc868dc&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__